import SocialLinkStyle from '@/styles/components/careers/navigation-section/_index.module.scss';
import { Formik, FormikControl, Form, InputError, InputStyle, useTranslation } from '@/imports-files/pages/career/customize-career-page';
export function SocialLinks({formik, sidebar_section, customizeCareerAction}){
  const {t} = useTranslation()
  return(
    <div className = {`${SocialLinkStyle.SocialLinks}`}>
      <label className = {`${SocialLinkStyle.SocialLinks__Title}`}>{t('career:nav_links:social')}</label>
      <div className = {`${SocialLinkStyle.SocialLinks__Fields}`}>
        <div className = {`${SocialLinkStyle.SocialLinks__Fields__LeftContent}`}>
          <div className = {`${SocialLinkStyle.SocialLinks__Fields__Label}`}>
            <label>{t('career:nav_links:x')}</label>
          </div>
          <div className={`${SocialLinkStyle.SocialLinks__Fields__Input}`}>
            <FormikControl
              control       =   "input"
              type          =   "text"
              placeholder   =   {t('career:nav_links:enter_url')}
              name          =   {"career_social_link_attributes.twitter_url"}
              className     =   {SocialLinkStyle.SocialLinks__Input}
              formik        =   {formik}
              onBlur      =   {(event) => customizeCareerAction.updateSocialLink(event,  formik)}
            />
          </div>
        </div>
        <div className = {`${SocialLinkStyle.SocialLinks__Fields__RightContent}`}>
          <div className = {`${SocialLinkStyle.SocialLinks__Fields__Label}`}>
            <label>{t('career:nav_links:facebook')}</label>
          </div>
          <div className={`${SocialLinkStyle.SocialLinks__Fields__Input}`}>
            <FormikControl
              control       =   "input"
              type          =   "text"
              placeholder   =   {t('career:nav_links:enter_url')}
              name          =   {"career_social_link_attributes.facebook_url"}
              className     =   {SocialLinkStyle.SocialLinks__Input}
              formik        =   {formik}
              onBlur      =   {(event) => customizeCareerAction.updateSocialLink(event,  formik)}
            />
          </div>
        </div>
      </div>
      <div className = {`${SocialLinkStyle.SocialLinks__Fields}`}>
        <div className = {`${SocialLinkStyle.SocialLinks__Fields__LeftContent}`}>
          <div className = {`${SocialLinkStyle.SocialLinks__Fields__Label}`}>
            <label>{t('career:nav_links:linkedIn')}</label>
          </div>
          <div className={`${SocialLinkStyle.SocialLinks__Fields__Input}`}>
            <FormikControl
              control       =   "input"
              type          =   "text"
              placeholder   =   {t('career:nav_links:enter_url')}
              name          =   {"career_social_link_attributes.linkedin_url"}
              className     =   {SocialLinkStyle.SocialLinks__Input}
              formik        =   {formik}
              onBlur      =   {(event) => customizeCareerAction.updateSocialLink(event,  formik)}
            />
          </div>
        </div>
        <div className = {`${SocialLinkStyle.SocialLinks__Fields__RightContent}`}>
          <div className = {`${SocialLinkStyle.SocialLinks__Fields__Label}`}>
            <label>{t('career:nav_links:instagram')}</label>
          </div>
          <div className={`${SocialLinkStyle.SocialLinks__Fields__Input}`}>
            <FormikControl
              control       =   "input"
              type          =   "text"
              placeholder   =   {t('career:nav_links:enter_url')}
              name          =   {"career_social_link_attributes.instagram_url"}
              className     =   {SocialLinkStyle.SocialLinks__Input}
              formik        =   {formik}
              onBlur      =   {(event) => customizeCareerAction.updateSocialLink(event,  formik)}
            />
          </div>
        </div>
      </div>
      <div className = {`${SocialLinkStyle.SocialLinks__Fields}`}>
        <div className = {`${SocialLinkStyle.SocialLinks__Fields__LeftContent}`}>
          <div className = {`${SocialLinkStyle.SocialLinks__Fields__Label}`}>
            <label>{t('career:nav_links:youtube')}</label>
          </div>
          <div className={`${SocialLinkStyle.SocialLinks__Fields__Input}`}>
            <FormikControl
              control       =   "input"
              type          =   "text"
              placeholder   =   {t('career:nav_links:enter_url')}
              name          =   {"career_social_link_attributes.youtube_url"}
              className     =   {SocialLinkStyle.SocialLinks__Input}
              formik        =   {formik}
              onBlur      =   {(event) => customizeCareerAction.updateSocialLink(event,  formik)}
            />
          </div>
        </div>
        <div className = {`${SocialLinkStyle.SocialLinks__Fields__RightContent}`}>
          &nbsp;
        </div>
      </div>
    </div>
  )
}